export default __webpack_public_path__ + "media/icons/icons_stars_active_lrg-4058040f.svg";